module.exports = __webpack_public_path__ + "img/symbol_9.217dad8e.png";